"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMPACT_NUMBER_OF_ROWS = 2;
exports.COMPACT_VIDEOS_IN_ROW = 2;
//# sourceMappingURL=compact-video-counts.js.map